/**
 * P0-DOB-SELF-DECLARATION-01 — structured backend error reader.
 *
 * FastAPI routes on this platform raise `HTTPException(detail={code, message})`.
 * Patient surfaces were rendering `detail` as if it were a string, so every
 * structured error (DOB_REQUIRED, DOB_INVALID, PATIENT_UNDER_18, acceptance
 * failures …) collapsed into a generic "Failed to …" message and the patient
 * never learned what to do.
 */
export const apiErrorCode = (error) => {
  const detail = error?.response?.data?.detail;
  if (detail && typeof detail === 'object') return detail.code || detail.error || null;
  return null;
};

export const apiErrorMessage = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  // A 422 `detail` is a LIST of pydantic errors. Rendering it as a React
  // child throws "Objects are not valid as a React child" and blanks the
  // page, so it is flattened to text here.
  if (Array.isArray(detail)) {
    const text = detail
      .map((e) => {
        const field = Array.isArray(e?.loc) ? e.loc[e.loc.length - 1] : '';
        return [field, e?.msg || e?.message].filter(Boolean).join(': ');
      })
      .filter(Boolean)
      .join(' · ');
    if (text) return text;
  }
  if (detail && typeof detail === 'object' && detail.message) return detail.message;
  const msg = error?.response?.data?.message;
  if (typeof msg === 'string' && msg.trim()) return msg;
  return fallback || error?.message || 'Request failed';
};

/** Codes raised by the canonical TREATX-L1-A transactional-eligibility gate. */
export const ELIGIBILITY_CODES = ['DOB_REQUIRED', 'DOB_INVALID', 'PATIENT_UNDER_18'];

export const isEligibilityError = (error) => ELIGIBILITY_CODES.includes(apiErrorCode(error));
